import { ReactElement } from "react";
import { Text } from "@mantine/core";
import FreeProductAnalyticsUsageGraph from "./UsageGraph";
import { TrackCard } from "@addons/components/TrackCard";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";

export function ManageCard({
  addOn,
}: IAddOnSlotProps<IMeteredAddOnDescriptor>): ReactElement {
  return (
    <TrackCard
      addOn={addOn}
      action={
        <Text c="gray.4" fw={700} fz="sm">
          Enabled
        </Text>
      }
      // harbormaster would let a customer cancel the grant; the store just
      // offers no control, so there is nothing for a blocked subscription to
      // grey out
      disabled={false}
      usage={<FreeProductAnalyticsUsageGraph addOn={addOn} />}
    />
  );
}
